    <div class="container-fluid">
        <div class="row mt-4">
            <div class="col-12">
                <h5 class="blue"><i class="fas fa-paper-plane"></i>&nbsp;Enviar carga</h5>
            </div>
        </div>
        <hr>
        <form #formEnviarCarga="ngForm" (ngSubmit)="formSubmit(formEnviarCarga)" novalidate="">
            <div class="container-fuid" style="height: 280px; overflow-y: auto; padding-right: 20px; overflow-x: hidden;">
                <div class="row mt-2" style="margin-right: 0px; margin-left: 0px;">
                    <div class="col-lg-12 col-md-12 col-sm-12 col-12">
                        <div class="form-group">
                            <label>Cuenta contable débito:</label>
                            <br>
                            <input type="text" autocomplete="off" readonly  placeholder="Cuenta contable de débito"
                            class="form-control form-control-sm  custom-input"  name="txtCuentaDebito" #txtCuentaDebito="ngModel" [(ngModel)]="cargaRQ.cuentaDebito" required> 
                        </div>
                    </div>
                </div> 
                <div class="row mt-2" style="margin-right: 0px; margin-left: 0px;">
                    <div class="col-lg-12 col-md-12 col-sm-12 col-12">
                        <div class="form-group">
                            <label>Cuenta contable crédito:</label>
                            <br>
                            <div class="input-group" >
                                <input type="text" autocomplete="off" readonly  placeholder="Cuenta contable de crédito"
                                    class="form-control form-control-sm  custom-input" name="txtCuentaCredito" #txtCuentaCredito="ngModel" [(ngModel)]="cargaRQ.cuentaCredito" required>
                            </div>    
                        </div>
                    </div>
                </div>
                <div class="row mt-2" style="margin-right: 0px; margin-left: 0px;">
                    <div class="col-lg-12 col-md-12 col-sm-12 col-12">
                        <div class="form-group">
                            <label>Equipo:</label>
                            <br>
                            <div class="input-group" >
                                <span class="input-group-text custom-input-group-text" style="height: 32px;" > {{ cargaRQ.idEquipo }} </span> 
                                <input type="text" autocomplete="off" readonly  placeholder="Equipo" name="txtEquipo" #txtEquipo="ngModel" [(ngModel)]="cargaRQ.equipo" required
                                    class="form-control form-control-sm  custom-input-group">
                            </div>    
                        </div>
                    </div>
                </div> 
                <div class="row mt-2" style="margin-right: 0px; margin-left: 0px;">
                    <div class="col-lg-4 col-md-4 col-sm-12 col-12">
                        <div class="form-group">
                            <label>Cantidad&nbsp;<i class="fas fa-gas-pump"></i></label>
                            <br>
                            <input class="input-group" type="number" autocomplete="off" readonly name="txtCantidad" #txtCantidad="ngModel"  [(ngModel)]="cargaRQ.cantidadCombustible" required
                            placeholder="Cantidad de combustible" class="form-control form-control-sm  custom-input" >   
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-12 col-12">
                        <div class="form-group">
                            <label>Combustible&nbsp;<i class="fas fa-oil-can"></i></label>
                            <br>
                            <input type="text"   autocomplete="off" readonly  placeholder="Combustible"
                                class="form-control form-control-sm  custom-input" name="txtTipoCombustible" #txtTipoCombustible="ngModel" [(ngModel)]="cargaRQ.tipoCombustible" required >  
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-12 col-12">
                        <div class="form-group">
                            <label>Costo Actual:</label>
                            <br>
                            <div class="input-group" >
                                <span class="input-group-text custom-input-group-text" ><i class="fas fa-dollar-sign"></i></span> 
                                <input type="number"   autocomplete="off" readonly  step="0.2"  placeholder="Costo actual" name="txtCostoActual" #txtCostoActual="ngModel"
                                    name="txtPrecio"class="form-control form-control-sm  custom-input-group"  [(ngModel)]="cargaRQ.costoActualCombustible" required >
                            </div>       
                        </div>
                    </div>
                </div> 
            </div>
            <div class="row mt-4">
                <div class="col text-end">
                    <button type="button" (click)="onClose()" class="btn btn-sm rounded-button btn-secondary">
                                <i class="fa fa-arrow-left"></i>
                                Regresar
                    </button>
                    <button type="button" (click)="abrirModalReenvio()" [disabled]="(isValid && idEstatus !== 'Entregado') || !isValid || seReenvio"  class="side-space btn btn-sm rounded-button btn-primary">
                        <i class="fa fa-check"></i>
                        Reenvío
                    </button>
                    <button type="submit" [disabled]="!formEnviarCarga.form.valid || isValid" class="side-space btn btn-sm rounded-button btn-success">
                        Aprobar
                        <i class="fa fa-check"></i>
                    </button>
                </div>
            </div>
        </form>
    </div>